import React, { Component } from 'react'

export class GreenButtonHeader extends Component {
  render() {
    return (
      <button className="greenButton headerBtn" onClick={this.props.nextStep}>
        {this.props.name}
      </button>
    )
  }
}

export default GreenButtonHeader